module.exports = __webpack_public_path__ + "static/media/faq2x2.6c2c9b5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faq2x2.png
// module id = 577
// module chunks = 1